module.exports = __webpack_public_path__ + "img/qr-code-printed-production-preview.3df13113.jpg";